import React from 'react';
interface GeometricPatternProps {
  pattern: 'circles' | 'square-rotate' | 'triangles' | 'diamond' | 'dots' | 'grid' | 'star' | 'hexagon';
  size?: 'small' | 'medium' | 'large';
  className?: string;
}
export function GeometricPattern({
  pattern,
  size = 'medium',
  className = ''
}: GeometricPatternProps) {
  const sizes = {
    small: {
      outer: 'w-4 h-4',
      inner: 'w-2 h-2',
      border: 'border'
    },
    medium: {
      outer: 'w-8 h-8',
      inner: 'w-4 h-4',
      border: 'border-2'
    },
    large: {
      outer: 'w-12 h-12',
      inner: 'w-6 h-6',
      border: 'border-2'
    }
  };
  const s = sizes[size];
  const patterns = {
    'square-rotate': <div className={`absolute inset-0 flex items-center justify-center ${className}`} data-id="element-1021">
        <div className={`${s.outer} ${s.border} border-current rounded-sm rotate-45 opacity-30`} data-id="element-1022" />
        <div className={`absolute ${s.inner} bg-current rounded-sm opacity-20`} data-id="element-1023" />
      </div>,
    circles: <div className={`absolute inset-0 flex items-center justify-center ${className}`} data-id="element-1024">
        <div className={`${s.outer} ${s.border} border-current rounded-full opacity-30`} data-id="element-1025" />
        <div className={`absolute ${s.inner} border border-current rounded-full opacity-20`} data-id="element-1026" />
        <div className="absolute w-2 h-2 bg-current rounded-full opacity-40" data-id="element-1027" />
      </div>,
    triangles: <div className={`absolute inset-0 flex items-center justify-center ${className}`} data-id="element-1028">
        <div className="w-0 h-0 border-l-[15px] border-r-[15px] border-b-[26px] border-transparent border-b-current opacity-30" style={{
        transform: 'translateY(-4px)'
      }} data-id="element-1029" />
        <div className="absolute w-0 h-0 border-l-[8px] border-r-[8px] border-b-[14px] border-transparent border-b-current opacity-20" style={{
        transform: 'translateY(6px)'
      }} data-id="element-1030" />
      </div>,
    diamond: <div className={`absolute inset-0 flex items-center justify-center ${className}`} data-id="element-1031">
        <div className={`${s.outer} ${s.border} border-current rotate-45 opacity-30`} data-id="element-1032" />
        <div className={`absolute ${s.inner} border border-current rotate-45 opacity-20`} data-id="element-1033" />
        <div className="absolute w-2 h-2 bg-current rotate-45 opacity-40" data-id="element-1034" />
      </div>,
    dots: <div className={`absolute inset-0 ${className}`} data-id="element-1035">
        <svg width="100%" height="100%" data-id="element-1036">
          <defs data-id="element-1037">
            <pattern id={`dots-${size}`} width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-1038">
              <circle cx="10" cy="10" r="1" fill="currentColor" opacity="0.3" data-id="element-1039" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={`url(#dots-${size})`} data-id="element-1040" />
        </svg>
      </div>,
    grid: <div className={`absolute inset-0 ${className}`} data-id="element-1041">
        <svg width="100%" height="100%" data-id="element-1042">
          <defs data-id="element-1043">
            <pattern id={`grid-${size}`} width="30" height="30" patternUnits="userSpaceOnUse" data-id="element-1044">
              <path d="M 30 0 L 0 0 0 30" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.15" data-id="element-1045" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={`url(#grid-${size})`} data-id="element-1046" />
        </svg>
      </div>,
    star: <div className={`absolute inset-0 flex items-center justify-center ${className}`} data-id="element-1047">
        <div className={`${s.outer} ${s.border} border-current rounded-sm opacity-30`} data-id="element-1048" />
        <div className={`absolute ${s.outer} ${s.border} border-current rounded-sm rotate-45 opacity-20`} data-id="element-1049" />
        <div className="absolute w-2 h-2 bg-current rounded-full opacity-40" data-id="element-1050" />
      </div>,
    hexagon: <div className={`absolute inset-0 ${className}`} data-id="element-1051">
        <svg width="100%" height="100%" data-id="element-1052">
          <defs data-id="element-1053">
            <pattern id={`hexagon-${size}`} width="50" height="43.4" patternUnits="userSpaceOnUse" data-id="element-1054">
              <path d="M25 0 L50 12.5 L50 37.5 L25 50 L0 37.5 L0 12.5 Z" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.2" data-id="element-1055" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill={`url(#hexagon-${size})`} data-id="element-1056" />
        </svg>
      </div>
  };
  return patterns[pattern] || null;
}